import { message } from 'antd';
import { ResourceApi } from '../api';
import { OntologyNode } from '../hooks/useResourceTree';

// 资源操作相关的工具函数
export class ResourceHelpers {
  // 删除资源
  static async deleteResource(nodeData: OntologyNode, targetDirId?: number) {
    try {
      console.log('🗑️ 删除资源:', nodeData.title, 'targetDirId:', targetDirId);

      if (!nodeData.id) {
        throw new Error('资源ID不存在');
      }

      await ResourceApi.deleteResource(nodeData.id, targetDirId);

      console.log('✅ 资源删除成功');
      message.success(`"${nodeData.title}" 删除成功`);

      return true;
    } catch (error: any) {
      console.error('❌ 删除资源失败:', error);
      message.error(`删除失败：${error.message || '未知错误'}`);
      return false;
    }
  }

  // 重命名资源
  static async renameResource(nodeData: OntologyNode, newName: string) {
    try {
      console.log('✏️ 重命名资源:', nodeData.title, '->', newName);

      if (!nodeData.id) {
        throw new Error('资源ID不存在');
      }

      await ResourceApi.renameResource(nodeData.id, newName);

      console.log('✅ 资源重命名成功');
      message.success(`重命名为 "${newName}" 成功`);

      return true;
    } catch (error: any) {
      console.error('❌ 重命名资源失败:', error);
      message.error(`重命名失败：${error.message || '未知错误'}`);
      return false;
    }
  }

  // 移动资源
  static async moveResource(sourceId: number, targetId: number) {
    try {
      console.log('📦 移动资源:', sourceId, '->', targetId);

      await ResourceApi.moveResource(sourceId, targetId);

      console.log('✅ 资源移动成功');
      message.success('移动成功');

      return true;
    } catch (error: any) {
      console.error('❌ 移动资源失败:', error);
      message.error(`移动失败：${error.message || '未知错误'}`);
      return false;
    }
  }

  // 确认创建文件夹
  static async createFolder(name: string, parentId?: number) {
    try {
      console.log('🚀 创建文件夹:', name, '父目录ID:', parentId);
      const newDirectory = await ResourceApi.createDirectory(name, parentId);
      console.log('✅ 文件夹创建成功:', newDirectory);

      message.success(`文件夹 "${name}" 创建成功`);
      return newDirectory;
    } catch (error: any) {
      console.error('❌ 创建文件夹失败:', error);
      message.error(`创建文件夹失败：${error.message || '未知错误'}`);
      throw error;
    }
  }

  // 确认创建本体
  static async createOntology(name: string, selectedDirectoryId?: number) {
    try {
      console.log('🚀 创建本体:', name, '父目录ID:', selectedDirectoryId);

      const newOntology = await ResourceApi.createResource(
        name,
        selectedDirectoryId,
        false
      );

      console.log('✅ 本体创建成功:', newOntology);
      message.success(`本体 "${name}" 创建成功`);

      return newOntology;
    } catch (error: any) {
      console.error('❌ 创建本体失败:', error);
      message.error(`创建本体失败：${error.message || '未知错误'}`);
      throw error;
    }
  }

  // 格式化时间显示
  static formatDateTime(dateTime: string) {
    return dateTime ? new Date(dateTime).toLocaleString('zh-CN') : '未知';
  }

  // 获取状态显示
  static getStatusDisplay(status: string) {
    return status === 'PUBLISHED' ? '已发布' : '未发布';
  }

  static getStatusColor(status: string) {
    return status === 'PUBLISHED' ? 'bg-green-400' : 'bg-gray-400';
  }
}